module.exports = {
      id: "phone-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }